// extracted by mini-css-extract-plugin
module.exports = {"tableInfo":"style__tableInfo__p5gUh","infoBox":"style__infoBox__u2k-O","infoBoxLeft":"style__infoBoxLeft__eLH9e","infoBoxRight":"style__infoBoxRight__ljHcg"};